import React from "react";
import { Grid, withStyles, Divider, Avatar, Checkbox } from "@material-ui/core";
import { getProLabelAndValue } from "../util";

const styles = (theme) => ({
  root: {
    paddingLeft: "0px",
    paddingTop: "8px",
    display: "flex",
    alignItems: "start",
    verticalAlign: "middle",
    height: "100%",
    color: theme.HeaderSelectedText,
    "&$checked": {
      color: theme.HeaderSelectedText,
    },
  },
  checkBoxLabel: {
    marginRight: "0px",
  },
  checked: {
    color: theme.HeaderSelectedText,
  },
  divStyle: {
    display: "flex",
    justifyContent: "center",
  },
  label: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.iconColor,
    lineHeight: "14px",
    fontWeight: 400,
    marginRight: "8px",
  },
  value: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.completeStopText,
    lineHeight: "14px",
    fontWeight: 600,
  },
  headerDivider: {
    backgroundColor: theme.gridIconBorderColor,
    opacity: 0.2,
    marginTop: 12,
  },
  billerName: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    textAlign: "left",
    display: "flex",
    lineHeight: "16px",
    color: theme.HeaderSelectedText,
  },
  avatar: {
    color: theme.infoTextColor,
    backgroundColor: theme.ComponentHeader,
    border: `1px solid ${theme.infoTextColor}`,
    width: 25,
    height: 25,
    fontSize: theme.headerTextFontSize,
  },
  billContainer: {
    marginTop: "16px",
  },
  noBillFound: {
    display: "flex",
    alignItems: "center",
    marginTop: "12px",
    fontWeight: 500,
    lineHeight: "16px",
    letterSpacing: "1px",
  },
});
const StopsList = (props) => {
  const { classes, stopList, handleStopSelection } = props;
  const totalBills = stopList.length;

  return stopList.map((stop, index) => {
    const proDetailsValue = getProLabelAndValue(
      stop.shipments
    )?.proDetailsValue;
    return (
      <Grid container spacing={8} className={classes.billContainer}>
        <Grid item>
          <Checkbox
            key="selectBill"
            classes={{
              root: classes.root,
              checked: classes.checked,
            }}
            disableRipple
            color="primary"
            onChange={() => handleStopSelection(stop.stopId)}
            checked={stop?.isChecked}
          />
        </Grid>
        <Grid item>
          <Avatar className={classes.avatar}>{stop.stopSequence}</Avatar>
        </Grid>
        <Grid item>
          <Grid item>
            <span className={classes.billerName}>{stop.name}</span>
          </Grid>
          <Grid item className={classes.label}>
            {stop.address}
          </Grid>
          <Grid item>
            <span className={classes.label}>Delivery Window:</span>
            <span className={classes.value}>
              {Boolean(stop.deliveryWindow) ? stop.deliveryWindow : "__:__"}
            </span>
          </Grid>
          <Grid item>
            <span className={classes.label}>Pro#</span>
            <span className={classes.value}>
              {Boolean(proDetailsValue) ? proDetailsValue : "__"}
            </span>
          </Grid>
        </Grid>
        {index < totalBills - 1 && (
          <Grid item xs={12}>
            <Divider className={classes.headerDivider} light={true} />
          </Grid>
        )}
      </Grid>
    );
  });
};

export default withStyles(styles)(StopsList);
